import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import moment from 'utils/cops-moment';
import { Row, Col } from 'antd';
import { SubTitle, FormItem, FormText, DatePicker } from 'ui';
import { FormattedDate, injectIntl } from 'react-intl';

const ColLighter = styled(Col)`
  margin-bottom: 10px;
  margin-top: 5px;
  padding-bottom: 5px;
  background-color: rgba(255, 255, 255, 0.5);
`;

// eslint-disable-next-line
class Dates extends Component {
  static propTypes = {
    data: PropTypes.object,
    isEditable: PropTypes.bool,
    form: PropTypes.object,
    disabled: PropTypes.bool,
    intl: PropTypes.object,
  };

  render() {
    const {
      validFromDate,
      startUpDate,
      acquisitionDate,
      warrStartDateVendor,
      warrEndDateVendor,
      warrStartDateCustomer,
      warrEndDateCustomer,
    } = this.props.data;

    const {
      isEditable,
      form,
      disabled,
      intl,
    } = this.props;
    const { getFieldDecorator } = form;

    const toDate = datetring => moment(datetring).isValid() ? moment(datetring) : null;

    const validFromDateValidator = getFieldDecorator('validFromDate', {
      initialValue: toDate(validFromDate),
    });

    const startUpDateValidator = getFieldDecorator('startUpDate', {
      initialValue: toDate(startUpDate),
    });

    const acquisitionDateValidator = getFieldDecorator('acquisitionDate', {
      initialValue: toDate(acquisitionDate),
    });

    const warrStartDateVendorValidator = getFieldDecorator('warrStartDateVendor', {
      initialValue: toDate(warrStartDateVendor),
    });

    const warrEndDateVendorValidator = getFieldDecorator('warrEndDateVendor', {
      initialValue: toDate(warrEndDateVendor),
    });

    const warrStartDateCustomerValidator = getFieldDecorator('warrStartDateCustomer', {
      initialValue: toDate(warrStartDateCustomer),
    });

    const warrEndDateCustomerValidator = getFieldDecorator('warrEndDateCustomer', {
      initialValue: toDate(warrEndDateCustomer),
    });

    return (
      <>
        <SubTitle>{intl.formatMessage({ id: 'common.titles.DATES' })}</SubTitle>
        <Row type='flex' gutter={16}>
          <Col md={8} sm={24} xs={24} data-test-id='dates.creation'>
            <FormItem label={intl.formatMessage({ id: 'dates.CREATION_DATE' })}>
              {isEditable ?
                validFromDateValidator(<DatePicker disabled={disabled} />)
                :
                <FormText>{validFromDate && <FormattedDate value={validFromDate} />}</FormText>
              }
            </FormItem>
          </Col>
          <Col md={8} sm={24} xs={24} data-test-id='dates.startup'>
            <FormItem label={intl.formatMessage({ id: 'dates.START_UP_DATE' })}>
              {isEditable ?
                startUpDateValidator(<DatePicker disabled={disabled} />)
                :
                <FormText>{startUpDate && <FormattedDate value={startUpDate} />}</FormText>
              }
            </FormItem>
          </Col>
          <Col md={8} sm={24} xs={24} data-test-id='dates.acquisition'>
            <FormItem label={intl.formatMessage({ id: 'dates.ACQUISITION_DATE' })}>
              {isEditable ?
                acquisitionDateValidator(<DatePicker disabled={disabled} />)
                :
                <FormText>{acquisitionDate && <FormattedDate value={acquisitionDate} />}</FormText>
              }
            </FormItem>
          </Col>
        </Row>
        <Row type='flex' gutter={16}>
          <ColLighter md={8} sm={24} xs={24} data-test-id='dates.customerwarranty.from'>
            <FormItem label={intl.formatMessage({ id: 'dates.CUSTOMER_WARRANTY_FROM' })}>
              {isEditable ?
                warrStartDateCustomerValidator(<DatePicker disabled={disabled} />)
                :
                <FormText>
                  {warrStartDateCustomer && <FormattedDate value={warrStartDateCustomer} />}
                </FormText>
              }
            </FormItem>
          </ColLighter>
          <ColLighter md={8} sm={24} xs={24}>
            <FormItem label={intl.formatMessage({ id: 'dates.TO' })}>
              {isEditable ?
                warrEndDateCustomerValidator(<DatePicker disabled={disabled} />)
                :
                <FormText>
                  {warrEndDateCustomer && <FormattedDate value={warrEndDateCustomer} />}
                </FormText>
              }
            </FormItem>
          </ColLighter>
        </Row>
        <Row type='flex' gutter={16}>
          <ColLighter md={8} sm={24} xs={24} data-test-id='dates.vendorwarranty.from'>
            <FormItem label={intl.formatMessage({ id: 'dates.VENDOR_WARRANTY_FROM' })}>
              {isEditable ?
                warrStartDateVendorValidator(<DatePicker disabled={disabled} />)
                :
                <FormText>
                  {warrStartDateVendor && <FormattedDate value={warrStartDateVendor} />}
                </FormText>
              }
            </FormItem>
          </ColLighter>
          <ColLighter md={8} sm={24} xs={24}>
            <FormItem label={intl.formatMessage({ id: 'dates.TO' })}>
              {isEditable ?
                warrEndDateVendorValidator(<DatePicker disabled={disabled} />)
                :
                <FormText>
                  {warrEndDateVendor && <FormattedDate value={warrEndDateVendor} />}
                </FormText>
              }
            </FormItem>
          </ColLighter>
        </Row>
      </>
    );
  }
}

export default injectIntl(Dates);
